import React from 'react';

import { CuiSignUpForm } from '../../components';

export const NewsletterSignUpForm = ({ ...rest }) => (
  <CuiSignUpForm
    title="Want more tips?"
    subTitle="Get more great tips on how to use CSS flexbox to build awesome user interfaces."
    formUrl={
      'https://cenizal.us11.list-manage.com/subscribe/post?u=72c0f1de10866c17e5f93e838&amp;id=d566048a86'
    }
    buttonLabel="Join the newsletter"
    {...rest}
  >
    I promise not to send you spam.
    <br />
    You can unsubscribe at any time.
  </CuiSignUpForm>
);



// WEBPACK FOOTER //
// ./ui/partials/newsletterSignUpForm/NewsletterSignUpForm.js